// extracted by mini-css-extract-plugin
export default {"Container":"PettCouple_Container__MlOzX","NameCouplePett":"PettCouple_NameCouplePett__Kwd5e","GroupImages":"PettCouple_GroupImages__rkhT8"};